export const REPLACE_TOKENS: Record<string, string> = {
  '6mxesxjeN': '6mxesxjee',
  at3pn5vvN: 'at3pn5vve',
  bpu56cazN: 'bpu56caze',
  jib4905zN: 'jib4905ze',
  mjf84067N: 'mjf84067e',
  '1mj4tv5jN': '1mj4tv5je',
  ybbux0qnN: 'ybbux0qne',
  m1hneracN: 'm1hnerace',
  nw8plwomN: 'nw8plwome',
  l32h5dppN: 'l32h5dppe',
  '7j1uepriN': '7j1ueprie',
  fqhj1e5oN: 'fqhj1e5oe',
  ehxnmjerN: 'ehxnmjere',
  woh0mvn4N: 'woh0mvn4e',
  e5kz6mcdN: 'e5kz6mcde',
  oaaqxzmzN: 'oaaqxzmze',
  n4ech51zN: 'n4ech51ze',
  '0fmscgzmN': '0fmscgzme',
  nkffr5o4N: 'nkffr5o4e',
  '65b56ufgN': '65b56ufge',
  wdykbqgsN: 'wdykbqgse',
  '5xfjrwfjN': '5xfjrwfje',
  zrxfspzkN: 'zrxfspzke',
  nrrbhtciN: 'nrrbhtcie',
  r5vniqirN: 'r5vniqire',
  m5ykbhgdN: 'm5ykbhgde',
  vahkdgqwN: 'vahkdgqwe',
  vwrkvsqkN: 'vwrkvsqke',
  fzva7ti2N: 'fzva7ti2e',
  '8qilyr7rN': '8qilyr7re',
  v42eqqfhi: 'j6ifcvthw',
  nekalcjjN: 'nekalcjje',
  c0qhfvpfN: 'c0qhfvpfe',
  '9je4ha1yN': '9je4ha1ye',
  '3ifb0yybN': '3ifb0yybe',
  etywf5bzN: 'etywf5bze',
  q37il73nN: 'q37il73ne',
  j1j15vxeN: 'j1j15vxee',
  vwhpzonqN: 'vwhpzonqe',
  '9nifaeceN': '9nifaecee',
  yqnk3tiaN: 'yqnk3tiae',
  abdbzjcwN: 'abdbzjcwe',
  uxvldxi2N: 'uxvldxi2e',
  hxf0nuvbN: 'hxf0nuvbe',
  '52nafbyhN': '52nafbyhe',
  '6cgpwcmbN': '6cgpwcmbe',
  pydaj2qsN: 'pydaj2qse',
  qpeg1iarN: 'qpeg1iare',
  '4hvgqdpsN': '4hvgqdpse',
  lfpbrp6eN: 'lfpbrp6ee',
  b4p0bz94N: 'b4p0bz94e',
  unjvbx9vN: 'unjvbx9ve',
  s84f0ynkN: 's84f0ynke',
  qas1urw2N: 'qas1urw2e',
  duvarabmN: 'duvarabme',
  umuul10zN: 'umuul10ze',
  '3fekef7gN': '3fekef7ge',
  m64gtcsiN: 'm64gtcsie',
  lhddzio7N: 'lhddzio7e',
  '50bcnx7kN': '50bcnx7ke',
  '4j6j0x61N': '4j6j0x61e',
  pxkiei1mN: 'pxkiei1me',
  hwc3uja3N: 'hwc3uja3e',
  orljqrgiN: 'orljqrgie',
  fsbo30ttN: 'fsbo30tte',
  k6a4n3cdN: 'k6a4n3cde',
  uc6hwm8qN: 'uc6hwm8qe',
  otav9vjzN: 'otav9vjze',
  '9fgh4kguN': '9fgh4kgue',
  zrjzdbg1N: 'zrjzdbg1e',
  dk1fncdsN: 'dk1fncdse',
  aekqvbh9N: 'aekqvbh9e',
  vegs1mklN: 'vegs1mkle',
  mouqplbuN: 'mouqplbue',
  mny9nr69N: 'mny9nr69e',
  unxlungaN: 'unxlungae',
  girtbht2N: 'girtbht2e',
  uto0325iN: 'uto0325ie',
  kcitvzjoN: 'kcitvzjoe',
  fceebrjuN: 'fceebrjue',
  ypntkehvN: 'ypntkehve',
  '0z4limbcN': '0z4limbce',
  xoyfdez8N: 'xoyfdez8e',
  f07txveaN: 'f07txveae',
  h9vxdktnN: 'h9vxdktne',
  '0jfgpekad': '0jfgpek',
  oezvlaymN: 'oezvlayme',
  vnew76yvN: 'vnew76yve',
  k1uvo9spN: 'k1uvo9spe',
  ayukjb9sN: 'ayukjb9sf',
  cyewsg01N: 'cyewsg01e',
  fmv3nquwN: 'fmv3nquwe',
  ljt0emioN: 'ljt0emioe',
  lpcs7hs6N: 'lpcs7hs6e',
  nf3nmbgrN: 'nf3nmbgre',
  rybusjocN: 'rybusjoce',
  uq5dhiv5N: 'uq5dhiv5e',
  vgr4d0buN: 'vgr4d0bue',
  xxckmhllb: '0vrmrbiva',
};
